import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import sleep from "sleep-promise";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const path = '/editals/';
    const paths = {
        endpointSave: config.endpoints.backend + 'editals/save',
        endpointGetById: config.endpoints.backend + 'editals/getById',
        endpointGetByEditalNumber: config.endpoints.backend + 'editals/getByEditalNumber',
        endpointGetAllProcesses: config.endpoints.backend + 'processes/getall',
        endpointGetProcessById: config.endpoints.backend + 'processes/getById',
        endpointGetAllEditalDocumentTypes: config.endpoints.backend + 'editaldocumenttypes/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Edital",
        labelTitleEdit: "Editar Edital",
        labelTitleView: 'Visualizar Edital'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'edital_number',
                    type: 'text',
                    mask: '999999/9999',
                    label: 'Número do Edital',
                    validations: {
                        required: true,
                        edital_number: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_process_id',
                    type: 'select',
                    label: 'Processo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProcesses,
                        label: 'process_number',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_project_id: values.pdc_project_id
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        const process_id = element.target.value

                        if (process_id != "") {
                            const process = await Fetch.post(paths.endpointGetProcessById, { id: process_id })
                            values.object = process.object
                        }

                        let form = getForm(values);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'object',
                    type: 'text',
                    label: 'Objeto',
                    columnSize: 6,
                    validations: {
                        required: false,
                    },
                    readOnly: true
                },
                {
                    name: 'files',
                    type: 'multiinput',
                    label: 'Arquivos do Edital',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_edital_document_type_id',
                            type: 'select',
                            label: 'Tipo de Documento',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllEditalDocumentTypes,
                                label: 'name',
                                value: 'id'
                            },
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'file',
                            type: 'fileS3',
                            extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                            limitFileSize: keys?.limitFileSizeDefault,
                            label: 'Arquivo',
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'limit_date',
                            type: 'date',
                            label: 'Data Limite',
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                edital_number: (value, options, key, attributes) => {
                    const checkEditalNumber = async (value) => {
                        const mask = /^\d{6}\/\d{4}$/
                        if (mask.test(value)) {
                            if (attributes.pdc_project_id) {
                                const post = {
                                    edital_number: value,
                                    pdc_project_id: attributes.pdc_project_id
                                };

                                const edital = await Fetch.post(paths.endpointGetByEditalNumber, post);

                                if (edital.id && edital.id != id) {
                                    return '^O número do processo já existe';
                                }
                            }
                        } else {
                            return "^O formato deve ser 000000/0000 (Número/Ano)";
                        }
                    }
                    return checkEditalNumber(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {
                object: "Não selecionado"
            };

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
